import { render, staticRenderFns } from "./product-report.vue?vue&type=template&id=46f88cf4&scoped=true&"
import script from "./product-report.vue?vue&type=script&lang=js&"
export * from "./product-report.vue?vue&type=script&lang=js&"
import style0 from "./product-report.vue?vue&type=style&index=0&id=46f88cf4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f88cf4",
  null
  
)

export default component.exports